import type { RootState } from "../app/store";

/**
 * What the guest's DSQ partner points paid of the order on the pay screen
 * (prepits/project#4437); 0 when they paid nothing.
 */
export const selectReceiptDsqPwpAmount = (state: RootState): number => {
  const amount = Number(state.receipt?.payScreenReceipt?.dsqpwpAmount);

  return Number.isFinite(amount) && amount > 0 ? amount : 0;
};

/** The partner whose points paid, e.g. "Vodafone"; null when unknown. */
export const selectReceiptDsqPwpPartnerName = (
  state: RootState
): string | null =>
  state.receipt?.payScreenReceipt?.dsqpwpProgramName?.trim() || null;
